import type { AssociatedVehicleInside } from "../../passapp-sdk/types/userTypes";

export enum UserActionType {
  USER_CHANGE_NAME,
  USER_ADD_AUTHORIZATION,
  USER_MARK_AUTHORIZATION,
  USER_TOGGLE_AUTHORIZATION,
  USER_HIDDEN_AUTHORIZATION,
  USER_SET_EVENT_ID,
  USER_IS_BLACK_LIST,
  USER_IS_RESIDENT,
  USER_RESET,
  USER_SET_SEARCH_COMPANION,
  USER_ADD_COMPANION,
  USER_DELETE_COMPANION,
  USER_SELECT_TYPE_VEHICLE,
  USER_SELECT_VEHICLE,
  USER_RESET_SELECT_VEHICLE,
  USER_SHOW_COMPANION_SECTION,
  USER_SHOW_DIALOG_COMPANION,
  USER_SET_VEHICLES,
  USER_NOT_NEW_VEHICLE,
  USER_IS_NEW_VEHICLE,
  USER_VEHICLE_START_LOADING,
  USER_VEHICLE_STOP_LOADING,
  USER_VEHICLE_FIELD_CHANGES,
  USER_VEHICLE_NEW_LOCAL_PHOTO,
  USER_BLACKLIST_AUTHORIZATION,
  USER_MARK_EXIT,
  USER_EDIT_EXIT,
  USER_ACEPT_UNKNOWN,
}

export enum GuestType {
  any = "any",
  provider = "provider",
}

export enum AuthorizationType {
  current = "current",
  awaitingRequest = "awaitingRequest",
  authorizedOnGuard = "authorizedOnGuard",
  lastEntrance = "lastEntrance",
}
export interface IAuthorization {
  id: string;
  authorization: any;
  mark: boolean;
  guestType: GuestType;
  type?: AuthorizationType;
  hidden: boolean;
}

export interface IAuthorizationType {
  type: string;
  show: boolean;
  authorization: IAuthorization[];
  error: string;
}

export interface IBlackUser {
  dni: string;
  countryCode: string;
  firstname: string;
  lastname: string;
  reason: string;
  blacklistedBy: string;
  id: string;
  restrictionType?: string;
}

export interface INewVehicle {
  id: string;
  plate: string;
  brand: string;
  model: string;
  color: string;
  insuranceExpirationDate: string;
  insurancePhoto: string;
  insurancePhotoNew: any;
}

export interface ISearchUser {
  dni?: string;
  countryCode?: string;
  qr?: string;
  pass?: string;
  passUserId?:string,
  firstname?: string;
  lastname?: string;
  sex?: string;
  birthdate?: string;
  rawQr?: string;
  rawPass?: string;
  userData?: any;
}

export type Config = {
  title?: "in" | "out";
  eventType?: "in" | "out";
  submit?: "in" | "out";
  companion?: boolean;
  userAddon?: any;
  userRequested?: string;
  newEventOut?: boolean;
  editMode?: boolean;
};
export interface INewVehicle {
  id: string;
  plate: string;
  brand: string;
  model: string;
  color: string;
  insuranceExpirationDate: string;
  insurancePhoto: string;
  insurancePhotoNew: any;
}

/** Legajo del chofer para una empresa de transporte puntual: el backend lo guarda por empresa,
 * no como un escalar del usuario. */
export interface TransportEmployeeNumber {
  transportCompany: string;
  employeeNumber: string;
}

export interface OldFields {
  firstname: string;
  lastname: string;
  countryCode: string;
  dni: string;
  driverLicenseExpirationDate: string;
  transportEmployeeNumber?: string;
  workMaterials: string;
  artCompanyName: string;
  artPolicyNumber: string;
  artExpirationDate: string;
  criminalRecordIssueDate: string;
  professionTypes: string[];
}

export enum UserFields {
  id = "id",
  firstname = "firstname",
  lastname = "lastname",
  countryCode = "countryCode",
  dni = "dni",
  config = "config",
  backDNI = "backDNI",
  frontDNI = "frontDNI",
  facePhoto = "facePhoto",
}

interface ResidenceInfo {
  long: number;
  lat: number;
  id: string;
  lotNumber: string;
  address?: string;
  allowExpressUsers?: boolean;
  authorizationsEnabled?: boolean;
  chartersEnabled?: boolean;
  landlineNumber?: string;
  maxPermanentPassesPerUser?: number;
  name?: string;
  permanentPassesEnabled?: boolean;
  providersEnabled?: boolean;
  requiresLandlineNumber?: boolean;
  type?: string;
  lot?: string;
  lotInfo?: {
    name: string;
    description: string;
    phone: string;
    country: string;
    disabled: boolean;
    aud_upd_date: string;
    admin: string;
    id: string;
  };
}

export interface Resident {
  firstname: string;
  lastname: string;
  dni: string;
  phone: string;
  residencesInfo: ResidenceInfo[];
  id: string;
}

interface RegisteredByOrSecurityGuard {
  email?: string;
  name?: string;
  securityGuard?: string;
  country: string;
  buildings?: null;
  areas?: null;
  id: string;
}

interface HostConfirmation {
  email: string;
  dni: string | null;
  countryCode: string | null;
  firstname: string;
  lastname: string;
  phone: string | null;
  registrationTimestamp: number;
  registrationType: string;
  registeredBy: any;
  language: string;
  sex: string;
  aud_ins_apikey: string;
  isWebAppUser: boolean;
  terms: boolean;
  facePhoto: string;
  residencesInfo: ResidenceInfo[];
  residences: string[];
  registrationReminderStatus: string;
  lastActivityTimestamp: number;
  resident: boolean;
  lotNumber: string;
  employee: boolean;
  employeeBuildings: any[];
  employeeCompanies: any[];
  employeeManagers: any[];
  entryAsResident: boolean;
  id: string;
}

interface EventData {
  country: string;
  invites: any[];
  hosts: any[];
  hostConfirmations: HostConfirmation[];
  vehicleType: string;
  aud_ins_date: string;
  securityGuard: RegisteredByOrSecurityGuard;
  aud_upd_date: string;
  authorizations: any[];
  comment: string;
  datetime: string;
  entriesAsProvider: any[];
  eventId: string;
  eventSource: string;
  lotIds: string[];
  lotNumbers: string[];
  lots: any[];
  otherAuthorizations: any[];
  overridedPhotos: any[];
  peopleComment: string;
  photos: any;
  timestamp: number;
  type: string;
  underagedCount: string;
  id: string;
}

export interface PersonInside {
  dni: string;
  countryCode: string;
  firstname: string;
  lastname: string;
  sex: string;
  registrationType: string;
  registeredBy: RegisteredByOrSecurityGuard;
  language: string;
  registrationTimestamp: number;
  driverLicenseExpirationDate: string;
  facePhoto: string;
  resident: boolean;
  lotNumber: string | null;
  employee: boolean;
  employeeBuildings: any[];
  employeeCompanies: any[];
  employeeManagers: any[];
  residencesInfo: any[];
  event: EventData;
  blacklistedData: any;
  comment: string;
  id: string;
  /** Legajo ya resuelto por el backend para la empresa con la que entró el camión. */
  transportEmployeeNumber?: string;
  transportEmployeeNumbers?: TransportEmployeeNumber[];
  /** Unidades con las que entró —la principal incluida—, cada una con su estado. Es autoritativo:
   * el backend resuelve `inside` contra el último evento de cada vehículo, igual que en
   * getVehiclesInside. */
  associatedVehicles?: AssociatedVehicleInside[];
}

